<template>
  <el-select
    style="width: 300px"
    v-model="localValue"
    :size="size"
    :multiple="multiple"
    :disabled="disabled"
    :clearable="clearable"
    :placeholder="placeholder"
    @change="selected"
    filterable
  >
    <el-option
      v-for="category in categories"
      :key="category.id"
      :label="category.name"
      :value="category.id"
    />
  </el-select>
</template>

<script>
export default {
  name: "categories-select",
  props: {
    value: '',
    size: { type: String, default: '' },
    disabled: { type: Boolean, default: false },
    multiple: { type: Boolean, default: true },
    clearable: { type: Boolean, default: true },
    placeholder: { type: String, default: 'Категория' },
  },
  data() {
    return {
      localValue: this.value,
      categories: [],
    };
  },
  watch: {
    value(newVal) {
      this.localValue = newVal;
    },
  },
  mounted() {
    this.$nextTick(() => {
      this.loadCategories();
    });
  },
  methods: {
    selected(value) {
      if (value === '') {
        value = null;
      }

      this.localValue = value;
      this.$emit('input', value);
      this.$emit('change', value);
    },
    loadCategories() {
      this.$api.evaluation.categorySearch()
        .then(({data}) => {
          this.categories = data.categories;
        });
    },
  },
};
</script>

<style>

</style>
